import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { FollowContainer } from 'bricks';
import { simulateResize } from 'utils/resize';

import FiltersWidget from '../FiltersWidget';
import {
  SidebarHeader,
  MobilePanel /* , ClearButton */,
  DisableFilter,
  SidebarFooter,
} from './components';
import { sidebarContentId, sidebarContainerId } from '../../constants';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class SidebarPanel extends React.PureComponent {
  render() {
    const { isMobile, isTablet, containerNode } = this.props;
    if (isTablet) {
      return (
        <MobilePanel>
          <div role="presentation" className={cx('filtersWrapper', 'mobile')}>
            <SidebarHeader isMobile={isMobile} isTablet={isTablet} className={cx('borderBottom')} />
            <DisableFilter>
              <div className={cx('overflowWrapper')}>
                <FiltersWidget isMobile={isMobile} className={cx('borderBottom')} />
              </div>
            </DisableFilter>
            <SidebarFooter isMobile={isMobile} />
          </div>
        </MobilePanel>
      );
    }
    return (
      <FollowContainer
        offsetTop={116}
        id={sidebarContainerId}
        containerNode={containerNode}
        watchResize
      >
        <div
          role="presentation"
          className={cx('filtersWrapper', isMobile && 'mobile')}
          onClick={() => requestAnimationFrame(simulateResize)}
          id={sidebarContentId}
        >
          <DisableFilter>
            <SidebarHeader />
            <FiltersWidget />
          </DisableFilter>
        </div>
      </FollowContainer>
    );
  }
}

SidebarPanel.propTypes = {
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  containerNode: PropTypes.any, // expected DOMNode
};
